import { useQuery } from "@apollo/client";
import { Center, Container, Loader, Paper, Text, Title } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { GET_USER } from "../../apis/lambda/GraphQL/User/queries";
import { userInfoAtom } from "../../atoms";

function StripeReturnPage() {
  // Jotai State
  const userInfo = useAtomValue(userInfoAtom);
  const [enableQuery, setEnableQuery] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setEnableQuery(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const userResponse = useQuery(GET_USER, {
    variables: { email: userInfo?.email! },
    skip: !userInfo?.email || !enableQuery,
    fetchPolicy: "network-only",
  });

  if (userResponse.loading || !enableQuery) {
    return (
      <Container>
        <Center style={{ height: "80vh" }}>
          <div>
            <Loader />
            <Text mt="md">Verifying your account details...</Text>
          </div>
        </Center>
      </Container>
    );
  }

  if (
    userResponse.error ||
    (!userResponse.loading && !userResponse.data?.user)
  ) {
    return (
      <Container>
        <Center style={{ height: "80vh" }}>
          <Paper withBorder shadow="md" p={30} radius="md">
            <Title order={2} ta="center">
              Something went wrong
            </Title>
            <Text ta="center" mt="md">
              We couldn't verify your account details. Please contact us if you
              need help.
            </Text>
          </Paper>
        </Center>
      </Container>
    );
  }

  if (!userResponse.data?.user?.payoutsEnabled) {
    return (
      <Container>
        <Center style={{ height: "80vh" }}>
          <Paper withBorder shadow="md" p={30} radius="md">
            <Title order={2} ta="center">
              Bank Account Not Linked
            </Title>
            <Text ta="center" mt="md">
              Either you didn't finish linking your bank account or something
              went wrong.
            </Text>
          </Paper>
        </Center>
      </Container>
    );
  }

  if (userResponse.data?.user?.payoutsEnabled) {
    return (
      <Container>
        <Center style={{ height: "80vh" }}>
          <Paper withBorder shadow="md" p={30} radius="md">
            <Title order={2} ta="center">
              Bank Account Successfully Linked!
            </Title>
            <Text ta="center" mt="md">
              Any money you make can now be transferred to your bank account.
            </Text>
          </Paper>
        </Center>
      </Container>
    );
  }
}

export default StripeReturnPage;
